import { render } from "./tab-allergies.vue?vue&type=template&id=8a167014&scoped=true"
import script from "./tab-allergies.vue?vue&type=script&lang=js"
export * from "./tab-allergies.vue?vue&type=script&lang=js"

import "./tab-allergies.vue?vue&type=style&index=0&id=8a167014&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a167014"]])

export default __exports__